import { render, staticRenderFns } from "./brokeragetotal.vue?vue&type=template&id=3cb3b5d1&"
import script from "./brokeragetotal.vue?vue&type=script&lang=js&"
export * from "./brokeragetotal.vue?vue&type=script&lang=js&"
import style0 from "./brokeragetotal.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports